module.exports = __webpack_public_path__ + "static/assets/729f69c0d05dd0f1776e07f53c8fcdff.png";